import { lazy } from "react";

export const LazyAssessmentTypeListPage = lazy(async () => ({
    default: (await import("./AssessmentTypeListPage")).AssessmentTypeListPage
}));

export const LazyAssessmentTypePage = lazy(async () => ({
    default: (await import("./AssessmentTypePage")).AssessmentTypePage
}));

export const LazyAssessmentTypeVersionPage = lazy(async () => ({
    default: (await import("./AssessmentTypeVersionPage"))
        .AssessmentTypeVersionPage
}));
